import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryHrLive } from "./baseQuery";
import { API } from "./constant";

export const employeeFloatApi = createApi({
  baseQuery: baseQueryHrLive,
  reducerPath: "employeeFloatApi",
  endpoints: (builder) => ({
    createEmployeeFloat: builder.mutation({
      query: (data) => ({
        url: `${API.EMPLOYEE.CREATE_FLOAT_REQUEST}`,
        method: "POST",
        body: data,
      }),
    }),
    getEmployeeFloatDashboard: builder.query({
      query: ({ year }) => ({
        url: `${API.EMPLOYEE.EMPLOYEE_FLOAT_DASHBOARD}?year=${year}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useCreateEmployeeFloatMutation,
  useGetEmployeeFloatDashboardQuery,
} = employeeFloatApi;
